import ComparisonModulesRenderer from '@/components/_rebrand/craft/ComparisonModulesRenderer';
import { TeamPathsQuery, TeamQuery, TeamQueryVariables } from '@/graphql';
import TeamQueryDocument from '@/graphql/queries/Team.gql';
import TeamPathsQueryDocument from '@/graphql/queries/TeamPaths.gql';
import ModularPageLayout from '@/layouts/ModularPageLayout';
import TeamsLegacyLayout from '@/layouts/pages/teams/TeamsLegacy';
import { getPageProps } from '@/lib/craft-page';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';
import { ModularPageProps, ParseModuleBuilderPropsInput, parseModuleBuilderProps } from '@/modules/ModuleBuilder';
import MasterTemplate from '@/templates/MasterTemplate';

const Team: PageTemplate<TeamQuery | ModularPageProps> = (props) => {
  if ('modularPageProps' in props) {
    return <ModularPageLayout props={props.modularPageProps} />;
  }

  const entry = 'entry' in props ? props.entry : null;
  const isRebrandModularEntry = entry?.__typename === 'teams_rebrandModular_Entry';

  if (entry && isRebrandModularEntry) {
    return <ComparisonModulesRenderer modules={entry.comparisonModules} />;
  }

  if (entry?.__typename) {
    return <TeamsLegacyLayout {...props} />;
  }

  return null;
};

Team.template = (props) => {
  const entry = 'entry' in props ? (props as TeamQuery).entry : null;
  const isRebrandModularEntry = entry?.__typename === 'teams_rebrandModular_Entry';

  return <MasterTemplate {...props} className={isRebrandModularEntry ? 'mt-0' : ''} />;
};

export default Team;

export const getStaticPaths = getStaticPagePaths('teams', async (context) => {
  const client = new CraftClient();

  const data = await client.request<TeamPathsQuery>(TeamPathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `teams/${params?.slug}`,
  async ({ client, context: { params } }) => {

    const pageProps = await getPageProps<TeamQuery, TeamQueryVariables>({
      pathPrefix: '/teams',
      queryDocument: TeamQueryDocument,
      client,
      variables: {
        slug: params?.slug,
      },
    });

    if (!pageProps?.entry) {
      return { notFound: true };
    }

    if (pageProps.entry.__typename === 'teams_modular_Entry') {
      return {
        props: parseModuleBuilderProps(pageProps as ParseModuleBuilderPropsInput)
      }
    }

    return {
      props: {
        ...pageProps,
      },
    };
  },
);
